const KEY = "agentui_last_login_method";
const VALID = ["google", "microsoft", "sso", "email"];

export function getLastLoginMethod() {
    try {
        const v = localStorage.getItem(KEY);
        return VALID.includes(v) ? v : null;
    } catch {
        return null;
    }
}

export function setLastLoginMethod(method) {
    try {
        if (VALID.includes(method)) localStorage.setItem(KEY, method);
    } catch {
        // localStorage unavailable — silently skip
    }
}
